// NOTE: no `g` flag. This regex is reused across yup `.matches()` validations, and a
// global-flag RegExp is stateful in `.test()` (its lastIndex advances), which made it
// intermittently reject valid URLs on repeated validations. The `m` flag was also a
// no-op here (no `^`/`$` anchors). Keep it flag-less for deterministic matching.
export const URL_REGEX =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/;

export const LETTER_REGEX = new RegExp(/^[A-Za-z\s]*$/);

export const DOMAIN_REGEX = /^[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}$/i;

export const EMAIL_REGEX = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;

export const DOMAIN_SECONDARY_REGEX =
  /^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9]$/;

export const NUMBERS_ONLY_REGEX = /^[0-9]*$/;

export const CLAY_WEBHOOKS_URL_REGEX =
  /^https:\/\/api\.clay\.com\/v\d+\/sources\/webhook.*$/;

export const ALPHANUMERIC_WITH_HYPHEN_UNDERSCORE_SPACE_REGEX =
  /^[a-zA-Z0-9]+[a-zA-Z0-9 _-]*[a-zA-Z0-9]+$/;

export const VALID_ASSET_FILENAME = /^[a-zA-Z0-9._-]+$/;

// Beeswax caps asset/creative filenames at 100 characters.
export const MAX_ASSET_FILENAME_LENGTH = 100;

// Sanitize a filename to the characters the backend/Beeswax accept: letters,
// digits, dot (extension), hyphen and underscore — no spaces or special
// characters — and cap it at 100 chars. Returns "" when nothing valid remains
// (callers decide how to treat an empty result).
export function cleanFileName(fileName: string) {
  fileName = fileName.trim();

  // Keep only accepted characters; drop anything else (quotes, symbols, etc.).
  // Spaces are handled below.
  fileName = fileName.replace(/[^a-zA-Z0-9._\- ]+/g, "");

  // Collapse whitespace that surrounds a "-"/"_" so "foo _ bar" -> "foo_bar".
  fileName = fileName.replace(/\s*([-_])\s*/g, "$1");

  // Convert any remaining interior whitespace to underscores — the backend
  // rejects file names containing spaces.
  fileName = fileName.replace(/\s+/g, "_");

  // Remove leading/trailing "-"/"_".
  fileName = fileName.replace(/^[-_]+|[-_]+$/g, "");

  // Enforce Beeswax's 100-char cap, preserving the extension where possible.
  if (fileName.length > MAX_ASSET_FILENAME_LENGTH) {
    const dot = fileName.lastIndexOf(".");
    if (dot > 0 && dot < fileName.length - 1) {
      const ext = fileName.slice(dot);
      const base = fileName.slice(0, dot);
      fileName = base.slice(0, MAX_ASSET_FILENAME_LENGTH - ext.length) + ext;
    } else {
      fileName = fileName.slice(0, MAX_ASSET_FILENAME_LENGTH);
    }
    // Re-trim in case truncation left a trailing separator.
    fileName = fileName.replace(/[-_]+$/g, "");
  }

  return fileName;
}
